'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormattedMessage = require('../../../components/Formatted/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _imageWithFallback = require('@liveauctioneers/caterwaul-components/lib/imageWithFallback');

var _imageWithFallback2 = _interopRequireDefault(_imageWithFallback);

var _reactFastCompare = require('react-fast-compare');

var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);

var _link = require('@liveauctioneers/caterwaul-components/lib/link');

var _link2 = _interopRequireDefault(_link);

var _Modal = require('../../../components/Modals/Shared/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _ModalHeader = require('../../../components/Modals/Shared/ModalHeader');

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SignUpEmail = require('./SignUpEmail');

var _SignUpEmail2 = _interopRequireDefault(_SignUpEmail);

var _urls = require('../../../utils/urls');

var _SignUpModal = require('./SignUpModal.scss');

var _SignUpModal2 = _interopRequireDefault(_SignUpModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var headerText = (0, _jsx3.default)(_FormattedMessage2.default, {
    id: 'sign_up_for_a_free_membership'
});

var SignUpModal = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(SignUpModal, _Component);

    function SignUpModal() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SignUpModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SignUpModal.__proto__ || (0, _getPrototypeOf2.default)(SignUpModal)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = function (nextProps) {
            return !(0, _reactFastCompare2.default)(_this.props, nextProps);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(SignUpModal, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                bidderExists = _props.bidderExists,
                cancelSignUp = _props.cancelSignUp,
                error = _props.error,
                isMobile = _props.isMobile,
                isTablet = _props.isTablet,
                openLoginModal = _props.openLoginModal,
                setEmail = _props.setEmail,
                show = _props.show,
                submitCreateAccount = _props.submitCreateAccount,
                submitted = _props.submitted,
                whiteLabel = _props.whiteLabel;


            var link = (0, _jsx3.default)(_link2.default, {
                onClick: openLoginModal
            }, 'link', (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'log_in'
            }));
            var footerContent = (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'already_have_an_account_sign_in_here',
                values: { link: link }
            });

            var modalHeader = (0, _jsx3.default)(_ModalHeader2.default, {
                onHide: cancelSignUp,
                content: headerText,
                hideLogo: whiteLabel
            });
            var modalLeftImage = isMobile && !isTablet ? null : (0, _jsx3.default)(_imageWithFallback2.default, {
                src: _urls.signupLadySmallUrl
            });
            var modalBody = (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)(_SignUpEmail2.default, {
                bidderExists: bidderExists,
                error: error,
                setEmail: setEmail,
                submitCreateAccount: submitCreateAccount,
                submitted: submitted
            }));
            var modalFooter = (0, _jsx3.default)('div', {}, void 0, footerContent);

            return (0, _jsx3.default)(_Modal2.default, {
                body: modalBody,
                contentLabel: 'SignUpModal',
                footer: modalFooter,
                footerClassName: _SignUpModal2.default.footer,
                header: modalHeader,
                leftImage: modalLeftImage,
                show: show
            });
        }
    }]);
    return SignUpModal;
}(_react.Component), _class.defaultProps = {
    error: '',
    show: false,
    submitted: false
}, _temp2);
exports.default = SignUpModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modals/SignUpModal/SignUpModal.js
// module id = GomR
// module chunks = 60